import templateUrl from "emun.auth/users/user-marketing-profile-prompt.htm";
import controller from "emun.auth/users/user-marketing-profile-prompt.controller";
import open from "webmodals/open";

export default ({
  size = "lg",
  backdrop = true,
  keyboard = true,
  title = "Marketing Profile...",
  user = {}
}) =>
  open({
    size,
    backdrop,
    keyboard,
    templateUrl,
    controller,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      title: () => title,
      user: () => user
    }
  }).result;
